export const PathURL = {
  dashboard: `/dashboard`,
  signin: '/signin',
  notfound:'/not-found',
  signup: '/signup',
  forgot_password: '/forgot-password',
  profile: `/profile`,
  user: `/user`,
  order:{
    list:'/orders',
    create:'/orders/create',
    edit:'/orders/edit/:id'
  },
  product:{
    list:"/products"

  },
  system: {
    team: `/system/team`,
    expected_revenue: `/system/expected-revenue`,
    sales_closing: `/system/sales-closing`,
    marketing_fee: `/system/marketing-fee`,
    marketing_username: `/system/marketing-user`,
    pagesPermission: `/system/page-permissions`,
    rolesPermission: `/system/roles-permission`,
    uploadSocial: `/system/upload-social`,
    bankCard: `/system/bank-card`,
    setting: `/system/settings`,
    currencyRate:"system/currency-rate"
  },
  report: {
    sales_report: `/report/sales-report`,
    digital_report: `/report/digital-report`,
    contact_report: `/report/contact`,
    refund_rate_report: `/report/refund-rate-report`,
    omicall_report: `/report/omicall-report`,
    new_customer_report:"/report/new-customer",
    page_message_statistic:"/report/thong-ke-tin-nhan",
    page_user_message_statistic:"/report/bao-cao-tin-nhan-user"
  },
  users: {
    create_user: `/user/create`
  },
  customer: `/customers`,
  digital_management: {
    setup_digital_marketing: `/digital-management/verify-account-digital`,
    ads_cost: `/digital-management/marketing-fee-actual`,
    other_cost: `/digital-management/marketing-fee-others`,
    marketing_fee_actual_index: `/digital-management/list-cost-ads`
  },
  social_management: {
    social_index: `/social-management/index`
  }
};
